import React from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Scan } from 'lucide-react';
import { Navigation } from './components/Navigation';
import { ScannerPage } from './pages/ScannerPage';
import { SignUpPage } from './pages/SignUpPage';
import RestaurantPage from './pages/RestaurantPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import MethodologyPage from './pages/MethodologyPage';
import { RequireAuth } from './components/RequireAuth';
import { useAuth } from './hooks/useAuth';

function App() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Handle deep links for password reset in mobile apps
    if (Capacitor.isNativePlatform()) {
      CapacitorApp.addListener('appUrlOpen', ({ url }) => {
        const slug = url.split('://').pop();
        if (slug?.startsWith('reset-password')) {
          navigate('/reset-password');
        }
      });
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <header className="bg-white shadow-sm sticky top-0 z-50">
          <div className="max-w-4xl mx-auto px-4 py-3 sm:py-4 flex justify-between items-center">
            <Link 
              to="/" 
              className="text-xl sm:text-2xl font-bold text-emerald-600 flex items-center gap-2 hover:text-emerald-700 transition-colors"
            >
              <Scan className="w-6 h-6 sm:w-8 sm:h-8" />
              Scan Halal
            </Link>
            <Navigation />
          </div>
        </header>

        <Routes>
          <Route path="/" element={<ScannerPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/methodology" element={<MethodologyPage />} />
          <Route path="/restaurants" element={
            <RequireAuth>
              <RestaurantPage />
            </RequireAuth>
          } />
          {/* Handle all variations of reset password routes */}
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify" element={<ResetPasswordPage />} />
          <Route path="/reset" element={<ResetPasswordPage />} />
          <Route path="/reset/*" element={<ResetPasswordPage />} />
        </Routes>
      </div>
    </>
  );
}

export default App;